import { __decorate } from "tslib";
import Vue from 'vue';
import { from, of } from "rxjs";
import RxUtils from "@/utils/rx";
import { catchError, map, startWith } from "rxjs/operators";
import Task from "@/services/task";
import Component from "vue-class-component";
let ReactiveComponent = class ReactiveComponent extends Vue {
    constructor() {
        super(...arguments);
        this.subscriptions = new Map();
        this.queries = new Map();
    }
    destroyed() {
        for (let subscription of this.subscriptions.values()) {
            subscription.unsubscribe();
        }
        this.subscriptions.clear();
        this.queries.clear();
    }
    subscribe(tag, stream, onNext) {
        if (this.subscriptions.has(tag)) {
            this.subscriptions.get(tag).unsubscribe();
        }
        const subscription = stream.subscribe(onNext);
        this.subscriptions.set(tag, subscription);
    }
    unsubscribe(tag) {
        if (this.subscriptions.has(tag)) {
            this.subscriptions.get(tag).unsubscribe();
            this.subscriptions.delete(tag);
        }
        if (this.queries.has(tag)) {
            this.queries.delete(tag);
        }
    }
    subscribeQuery({ tag, options, onTask }) {
        if (this.subscriptions.has(tag)) {
            this.subscriptions.get(tag).unsubscribe();
        }
        const query = this.$apollo.provider.defaultClient.watchQuery(options);
        const subscription = RxUtils.fromQuery(query).pipe(map(result => {
            // console.log(result)
            return Task.success(result.data);
        }), startWith(Task.loading()), catchError(error => of(Task.failure(error.message)))).subscribe(task => {
            console.log(`[${tag}] ${task}`);
            onTask(task);
        });
        this.subscriptions.set(tag, subscription);
        this.queries.set(tag, query);
    }
    subscribeMutation({ tag, options, onTask }) {
        if (this.subscriptions.has(tag)) {
            this.subscriptions.get(tag).unsubscribe();
        }
        const promise = this.$apollo.provider.defaultClient.mutate(options);
        const subscription = from(promise).pipe(map(result => {
            // console.log(result)
            return Task.success(result.data);
        }), startWith(Task.loading()), catchError(error => of(Task.failure(error.message)))).subscribe(task => {
            console.log(`[${tag}] ${task}`);
            onTask(task);
        });
        this.subscriptions.set(tag, subscription);
    }
};
ReactiveComponent = __decorate([
    Component({})
], ReactiveComponent);
export default ReactiveComponent;
